import { Individual, Newsletter, Stats } from './pages';

export default {
  key: 'newsletter',
  hasSidebar: true,
  isPrivate: true,
  exact: false,
  path: '/schools/:sid/school-newsletters/:nid',
  component: Newsletter,
  routes: [
    {
      key: 'stats',
      exact: true,
      path: '/schools/:sid/school-newsletters/:nid',
      component: Stats,
    },
    {
      key: 'individual',
      exact: true,
      path: '/schools/:sid/school-newsletters/:nid/individual',
      component: Individual,
    },
  ],
};
